module.exports = __webpack_public_path__ + "static/media/kimpo.2647b424.png";